import { pathOr } from 'rambda';
import { map as lmap } from 'lodash/fp';
import { Either, left, right, fold, map as emap } from 'fp-ts/lib/Either';
import { flow } from 'fp-ts/function';
import { csosUpmApi, IError, ResponseCSOSHeaders } from '../common';
import { IStatusLegacies } from '.';

export const searchLegacyStatus =
  (hR: ResponseCSOSHeaders) =>
  ({ page, pageSize }: { page: number; pageSize: number }) =>
    csosUpmApi(hR)
      .get(`v1/api/admin/legacy-request?page=${page}&sizePerPage=${pageSize}`)
      .then(
        flow(
          pathOr<IStatusLegacies>({ total: 0, content: [] }, 'data'),
          // always({ total: 20, content: statusLegacies }),
          right
        )
      )
      .catch(e => left(e as IError));
